import type { ReactNode } from 'react'

/** La pastille ambre du bandeau du lecteur : ce qui s'y passe n'est pas enregistré. */
function NoTrackingPill({ children }: { children: ReactNode }) {
  return (
    <span className="shrink-0 rounded-full bg-amber-500/15 px-2 py-0.5 text-xs font-medium text-warning-text">
      {children}
    </span>
  )
}

export default NoTrackingPill
